import { requestApi } from "../funcitons";
import config from "../../config/config";
import tokenUtils from "../../utils/token";

export default {
    /**
     * Génère du texte à partir d'un prompt
     */
    generateText: async (prompt, options = {}) => {
        const res = await requestApi('ai/text', 'POST', {
            prompt,
            model: options.model,
            maxTokens: options.maxTokens,
            temperature: options.temperature
        });
        return res.data;
    },

    /**
     * Génère une image à partir d'un prompt
     */
    generateImage: async (prompt, options = {}) => {
        const res = await requestApi('ai/image', 'POST', {
            prompt,
            size: options.size || '1024x1024',
            quality: options.quality || 'standard',
            style: options.style || 'vivid',
            n: options.n || 1
        });
        return res.data;
    },

    /**
     * Génère une image avec une image de référence
     */
    generateImageWithReference: async (prompt, referenceImageBase64, options = {}) => {
        const res = await requestApi('ai/image-with-reference', 'POST', {
            prompt,
            referenceImageBase64,
            size: options.size || '1024x1024',
            n: options.n || 1
        });
        return res.data;
    },

    /**
     * Génère un composant HTML/CSS/JS
     */
    generateComponent: async (description, options = {}) => {
        const res = await requestApi('ai/component', 'POST', {
            description,
            style: options.style || 'modern'
        });
        return res.data;
    },

    /**
     * Génère du texte en streaming (Server-Sent Events)
     * @param {string} prompt - Le prompt
     * @param {function} onChunk - Callback appelé pour chaque chunk reçu
     * @param {object} options - Options supplémentaires
     */
    generateTextStream: async (prompt, onChunk, options = {}) => {
        const token = await tokenUtils.getToken();
        
        const response = await fetch(`${config.API_URI}/ai/text-stream`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                prompt,
                model: options.model,
                maxTokens: options.maxTokens,
                temperature: options.temperature
            })
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let fullText = '';

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value);
            const lines = chunk.split('\n').filter(line => line.trim());

            for (const line of lines) {
                if (line === 'data: [DONE]') {
                    return fullText;
                }
                if (line.startsWith('data: ')) {
                    try {
                        const json = JSON.parse(line.slice(6));
                        if (json.chunk) {
                            fullText += json.chunk;
                            onChunk(json.chunk, fullText);
                        }
                        if (json.error) {
                            throw new Error(json.error);
                        }
                    } catch (e) {
                        console.error('Error parsing chunk:', e);
                    }
                }
            }
        }

        return fullText;
    }
};

